import { render } from "./page-valuation.vue?vue&type=template&id=5a7fa1c6"
import script from "./page-valuation.js?vue&type=script&lang=js"
export * from "./page-valuation.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__